import {
    Checkbox,
    FormControl,
    FormControlLabel,
    FormGroup,
    FormLabel,
} from "@mui/material";
import { useContext, useState } from "react";

import { LanguageContext } from "src/contexts/language";
import { MapContext } from "src/contexts/map";
import { Type_Props_Input } from "src/types/input";
import { handleInputBlur } from "src/utils/element";

const CheckboxTextField = ({ data }: Type_Props_Input) => {
    const { language } = useContext(LanguageContext);
    const { newElement, updateNewElement } = useContext(MapContext);
    const [selectedValues, setSelectedValues] = useState<string[]>(
        (newElement?.data?.find((input) => input.input_id === data.id)
            ?.value as string[]) || [],
    );

    const handleCheckboxChange = (
        event: React.ChangeEvent<HTMLInputElement>,
    ) => {
        const value = event.target.value;
        if (event.target.checked) {
            setSelectedValues((prev) => [...prev, value]);
        } else {
            setSelectedValues((prev) => prev.filter((v) => v !== value));
        }
    };

    if (!data) return null;

    return (
        <FormControl
            component="fieldset"
            onBlur={() =>
                handleInputBlur({
                    data,
                    selectedValue: selectedValues,
                    newElement,
                    updateNewElement,
                })
            }
        >
            <FormLabel component="legend">{data.title[language]}</FormLabel>
            <FormGroup aria-label="position" row>
                {data.options?.map((option, index) => (
                    <FormControlLabel
                        key={index}
                        control={
                            <Checkbox
                                onChange={handleCheckboxChange}
                                value={option.value}
                                checked={selectedValues.includes(option.value)}
                            />
                        }
                        label={option.label}
                        labelPlacement="end"
                    />
                ))}
            </FormGroup>
        </FormControl>
    );
};

export default CheckboxTextField;
